<template>
  <div
    :class="{[getCss('container__bg')]: showDefaultBg, 'csu-clickable': clickable, 'csu-top-all': topAll}"
    :style="{
      ...styles.base,
      ...baseExtendStyle
    }"
    @click="handleClickEvent()"
    @mouseenter="handleEvent('hover')"
  >
    <div
      :class="getCss('fill-container')"
      :style="animateStyle"
    >
      <!-- 图片 -->
      <img
        v-show="showComponent"
        v-if="type === 'image' && imageSrc"
        :class="[nowStatusConfig.equalScale ? getCss('contain') : getCss('fill')]"
        v-src="imageSrc"
        width="100%"
        height="100%"
        :alt="imageSrc"
      >
      <!-- 文本 -->
      <div
        v-else-if="type === 'text'"
        :style="{
          ...nowStatusConfig.style,
        }"
      >
        {{ nowStatusConfig.style.textContent }}
      </div>
      <!-- 图标 -->
      <div
        v-else-if="type === 'icon' && nowStatusConfig && nowStatusConfig.style"
        :class="getCss('fill-container')"
        :style="{
          color: nowStatusConfig && nowStatusConfig.style.color,
        }"
        v-html="nowStatusConfig.style.image.svg"
      />
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import 'animate.css';
// 空状态标志
const EMPTY_STATUS = Symbol('empty status');
export default {
  name: 'CDynamicComponent',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'dynamic-',
      fileKeyCache: new Map(), // 缓存已经获取到到图片路径
      tempStatus: '',
      inTempStatus: false,
      tempStatusLockedTimer: -1,
      topAll: false,
      inAnimation: false,
      interval: -1,
      eventUid: '',
      mounted: false,
      statusFlowidArr: [],
      statusTimeArr: [],
      statusAcctypeArr: [],
      statusArr: [],
    };
  },
  computed: {
    type() {
      return this.configurationData.configs.type || 'image';
    },
    statusList() {
      return this.configurationData.configs.statusList || [];
    },
    // 当前页面展示的状态
    nowStatus() {
      console.info('nowStatusConfig.this.inTempStatus', this.inTempStatus);
      if (this.inTempStatus) {
        return this.configurationData.configs.activeStatus;
      }
      // 没拿到匹配值 展示默认
      if (this.statusArr.length > 0) {
        return this.statusArr[0];
      }
      return this.configurationData.configs.activeStatus;
    },
    showComponent() {
      return this.nowStatus !== 'hide';
    },
    nowStatusConfig() {
      console.info('nowStatusConfig.this.statusList', this.statusList);
      const { config = {} } = this.statusList.find(item => item.value === this.nowStatus) || {};
      console.info('nowStatusConfig', config);
      console.info('nowStatusConfig.this.nowStatus', this.nowStatus);
      // 预留switch,todo 针对具体类型做特殊处理
      switch (this.type) {
        case 'image':
        case 'text':
        case 'icon':
          break;
        default:
          break;
      }
      return config;
    },
    nowEventUid() {
      const { fileKey = '' } = this.nowStatusConfig;
      return fileKey;
    },
    imageSrc() {
      if (this.type !== 'image') return '';
      return this.nowStatusConfig.src || '';
    },
    showDefaultBg() {
      if (this.mounted) return false;
      if (!this.showComponent) return false;
      if (this.type === 'text') return false;
      if (this.type === 'image' && this.imageSrc) return false;
      if (this.type === 'icon' && this.nowStatusConfig.style?.image?.svg) return false;
      return true;
    },
    baseExtendStyle() {
      const extendStyle = {};
      // 在动画为bounce时,父容器overflow需要设置为visible
      if (this.nowStatusConfig.style?.animate?.['animation-name'] === 'bounce' || this.inAnimation) {
        extendStyle.overflow = 'visible';
      }
      // 没有任何一个状态匹配时,组件隐藏
      if (this.nowStatus === EMPTY_STATUS) {
        extendStyle.display = 'none';
      }
      return extendStyle;
    },
    nowTimeStr() {
      return new Date().getTime();
    },
    animateStyle() {
      return this?.nowStatusConfig?.style?.animate ?? {};
    },
  },
  mounted() {
    this.mounted = true;
    this.initialize();
  },
  methods: {
    initialize() {
      // 是否需要时间判断  拿到匹配数组
      if (this.configurationData.needTime) {
        this.timeLimitStatus();
      }
      console.log('this.configurationData', this.configurationData);
      console.log('this.configurationData.refreshTimeStatus', this.configurationData.refreshTimeStatus);
      if (this.configurationData.refreshTimeStatus === 'login') {
        const self = this;
        this.$onLogined(async () => {
          await self.refreshTime();
        });
      }
      if (this.configurationData.refreshTimeStatus === 'role') {
        const self = this;
        this.$onRoleReady(async () => {
          await self.refreshTime();
        });
      }
    },
    async setTempStatus({ status, topAll, animation }) {
      console.info('this.statusList.setTempStatus', animation);
      if (this.inAnimation) return;
      clearTimeout(this.tempStatusLockedTimer);
      const currentIndex = Math.max(this.statusList.findIndex(item => item.value === this.nowStatus), 0);
      const statusLen = this.statusList.length;
      if (status === 'prev') {
        const preIndex = (statusLen + currentIndex - 1) % statusLen;
        this.tempStatus = this.statusList[preIndex].value;
      } else if (status === 'next') {
        const nextIndex = (statusLen + currentIndex + 1) % statusLen;
        this.tempStatus = this.statusList[nextIndex].value;
      } else {
        this.tempStatus = status;
      }
      this.topAll = topAll;
      this.inTempStatus = true;
      animation && this.animate(animation);
      /**
       * 将以下逻辑注释,保持tempStatus不被刷走
       */
      // this.tempStatusLockedTimer = setTimeout(() => {
      //   this.inTempStatus = false;
      //   this.topAll = false;
      //   clearTimeout(this.tempStatusLockedTimer);
      // }, 3000);
    },
    animate(animation) {
      this.animateOut(animation);
      this.$nextTick(() => {
        this.animateIn(animation);
      });
    },
    animateIn({ animationName, animationDuration }) {
      const inEl = this.$el.firstElementChild.cloneNode(true);
      inEl.classList.add(this.getCss('repeated-el'));
      inEl.classList.remove(this.getCss('hide'));
      inEl.setAttribute('style', `animation-name: ${animationName}; animation-duration: ${animationDuration}ms`); // 清除原有的动画
      this.$el.appendChild(inEl);
      setTimeout(() => {
        this.$el.removeChild(inEl);
      }, animationDuration);
    },
    // 移出动画固定为为淡出
    animateOut({ animationDuration }) {
      this.inAnimation = true;
      const outEl = this.$el.firstElementChild.cloneNode(true);
      this.$el.firstElementChild.classList.add(this.getCss('hide'));
      outEl.classList.add(this.getCss('repeated-el'), this.getCss('fade-out'));
      outEl.setAttribute('style', `animation-duration: ${animationDuration}ms`); // 清除原有的动画
      outEl.classList.add('rotateInDownLeft');
      this.$el.appendChild(outEl);
      setTimeout(() => {
        this.$el.removeChild(outEl);
        this.$el.firstElementChild.classList.remove(this.getCss('hide'));
        this.inAnimation = false;
      }, animationDuration);
    },
    // 刷新时间
    async refreshTime() {
      // console.info('nowStatusConfig.this.statusTimeArr', statusArr);
      if (this.configurationData.needAcctype) {
        await this.acctypeLimitStatus();
        // 如果匹配数组已存在值  进行匹配重复值
        if (this.statusArr.length > 0 && this.statusAcctypeArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusAcctypeArr);
        } else {
          if (this.statusAcctypeArr.length > 0) {
            this.statusArr = this.statusAcctypeArr;
          }
        }
      }
      console.info('nowStatusConfig.this.statusAcctypeArr', this.statusArr);
      // 是否需要根据流程判断返回  拿到匹配数组
      if (this.configurationData.needFlow) {
        await this.flowidLimitStatus();
        if (this.statusArr.length > 0 && this.statusFlowidArr.length > 0) {
          this.statusArr = this.getArrEqual(this.statusArr, this.statusFlowidArr);
        } else {
          if (this.statusFlowidArr.length > 0) {
            this.statusArr = this.statusFlowidArr;
          }
        }
      }
      console.info('nowStatusConfig.this.statusFlowidArr', this.statusArr);
    },
    // 流程返回判断   目前不支持传参获取状态
    async flowidLimitStatus() {
      // 根据配置读取返回值
      const response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params: {
          role: this.roleInfo,
        },
      });
      // 响应 {"ret":0,"msg":"","data":"{\"level\":7,\"ret\":0}"}
      console.info('this.statusList.dynamic.response', response);
      const fieldStrObj = response.data || { ret: -1 };
      // console.info('this.statusList.dynamic.fieldStrObj', fieldStrObj);
      if (fieldStrObj.ret === -1) {
        return;
      }
      // 根据返回值与配置的列表进行匹配
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style) {
            const { fieldStr, fieldValueStr } = item.config.style.animate;
            if (typeof fieldValueStr === undefined || typeof fieldStr === undefined) {
              return;
            }
            const fieldArr = fieldValueStr.split('|');
            // console.log('this.statusList.fieldStr', `(fieldStrObj.${fieldStr})`);
            // console.log('this.statusList.fieldStr', fieldStrObj[fieldStr]);
            console.log('this.statusList.fieldArr', fieldArr);
            if (fieldStr && fieldArr.length > 0 && this.isInArray(fieldArr, fieldStrObj[fieldStr])) {
              console.log('this.statusList.value.flowidLimitStatus', item.value);
              if (!this.isInArray(this.statusFlowidArr, item.value)) {
                this.statusFlowidArr.push(item.value);
              }
            }
          }
        });
      }
    },
    // 时间判断
    timeLimitStatus() {
      if (this.$isInEditor) return;
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style) {
            const startTime = item.config.style.animate.startTime.replace(/-/g, '/');
            const endTime = item.config.style.animate.endTime.replace(/-/g, '/');
            // 根据前端获取的当前时间与配置时间进行匹配
            if (startTime && endTime && parseInt(this.nowTimeStr, 10) > parseInt(this.getTime(startTime), 10)
              && parseInt(this.nowTimeStr, 10) <= parseInt(this.getTime(endTime), 10)) {
              if (!this.isInArray(this.statusArr, item.value)) {
                this.statusArr.push(item.value);
              }
            }
          }
        });
      }
    },
    // 登录类型判断
    acctypeLimitStatus() {
      console.info('this.statusList', this.statusList);
      if (this.statusList !== undefined && this.statusList.length > 0) {
        this.statusList.forEach((item) => {
          if (item.config.style) {
            const { acctypeStr } = item.config.style.animate;
            console.log('this.statusList.value.acctypeStr', acctypeStr);
            // 根据当前登录的acctype  与配置的进行匹配
            let acctype = this.getCookie('acctype');
            console.log('this.statusList.value.acctype', acctype);
            if (acctype === 'pt' && acctypeStr !== 'pt') {
              acctype = 'qc';
            }
            if (acctypeStr === acctype && !this.isInArray(this.statusAcctypeArr, item.value)) {
              console.log('this.statusList.value.acctypeLimitStatus', item.value);
              this.statusAcctypeArr.push(item.value);
            }
          }
        });
      }
    },
    getTime(str) {
      return new Date(str).getTime();
    },
    getArrEqual(arr1, arr2) {
      const newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr1[j] === arr2[i]) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    isInArray(arr, val) {
      let status = false;
      for (let i = 0; i < arr.length; i++) {
        if (val.toString() === arr[i].toString()) {
          status = true;
        }
      }
      return status;
    },
    getCookie(key) {
      const reg = new RegExp(`(^| )${key}=([^;]*)(;|$)`);
      const arr = document.cookie.match(reg);
      if (arr) {
        return arr[2];
      }
      return null;
    },
  },
};
</script>
<style lang="scss">
@import './dynamic.scss';
</style>
